import React from 'react'
import './onebluecard.scss'
import { Col, Row } from 'react-bootstrap'
import { NavLink } from 'react-router-dom'
const OneBlueCard = ({ data }) => {
    return (
        <div>
            {/* talk section */}
            <div className='lets-talk'>
                <Row>
                    <Col sm={12} md={8} lg={8} xl={8}>
                        <div className='left-details'>
                            <div className='Heading'>
                                <h3>{data.heading1}</h3>
                            </div>
                            <div className='text'>
                                <p>{data.para1}</p>
                                <p>{data.para2}</p>
                                <p>{data.para3}
                                    <NavLink to={''}>{data.links}</NavLink></p>
                            </div>
                        </div>
                    </Col>
                    <Col sm={12} md={4} lg={4} xl={4}>
                        <div className='talk-right'>
                            <h3>{data.blue_card_heading}</h3>
                            <p>{data.blue_card_para}</p>
                            <button className='request-btn'>{data.button_text}</button>
                        </div>
                    </Col>
                </Row>
            </div>
        </div>
    )
}

export default OneBlueCard
